const brandConfig = {
    brand: {
        filterLayout: 'BrandFilterDefaultLayout',
        listLayout: 'BrandListDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        listApiParamSet: {
            ip: 1,
            sp: 10,
            page: 1,
        },
        pageRow: 10,
        paginationType: 'pagination',
        getFunc: 'getBrandList',
        excelParamSet:{
            excel:1,
        },
        // excelDownloadFunc:'brand',
        excelDownloadName:'브랜드 목록'
    },
    writeBrand: {
        writeLayouts: ['MemberWriteDefaultLayout'],
        writeFunc: 'createBrand',
        writeApiParamSet: {
        },
        parsingData: {
            b_name: 'b_name',
            b_introduce: 'b_introduce',
            b_lookbook_display: 'b_lookbook_display',
            b_gender: 'b_gender',
        },
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {
            100: '보내는 값이 잘못 되었습니다.',
            109: '중복된 브랜드입니다.',
            2: '권한없음',
        },
        writeFailMsg: '브랜드를 등록할 수 없습니다.',
        fileUploadFailMsg: '파일 등록에 실패하였습니다.',
        fileInfo: [
            {
                fileName: 'home_brand',
                fileType: 'home_brand',
                required: false,
                validatorMsg: '홈 원형 이미지를 추가해주세요.',
            },
            {
                fileName: 'introduce_brand',
                fileType: 'introduce_brand',
                required: false,
                validatorMsg: '브랜드 소개 이미지를 추가해주세요.',
            },
            {
                fileName: 'detail_brand',
                fileType: 'detail_brand',
                required: false,
                validatorMsg: '대표이미지를 추가해주세요.',
            },
            {
                fileName: 'look_book_brand',
                fileType: 'look_book_brand',
                required: false,
                validatorMsg: '브랜드 룩북 이미지를 추가해주세요.',
            },
            {
                fileName: 'square_brand',
                fileType: 'square_brand',
                required: false,
                validatorMsg: '브랜드 사각형 이미지를 추가해주세요.',
            },
        ],
    },
    updateBrand: {
        getFunc: 'getBrandList',
        detailApiParamSet: {
            ip: 0,
            hbf:1,
            bdf:1,
            ib:1,
            bdlf:1,
            sb:1,
        },
        writeFunc: 'updateBrand',
        writeLayouts: ['MemberWriteDefaultLayout'],
        writeApiParamSet: {
        },
        parsingData: {
            b_name: 'b_name',
            b_introduce: 'b_introduce',
            b_lookbook_display: 'b_lookbook_display',
            b_gender: 'b_gender',
        },
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {
            100: '보내는 값이 잘못 되었습니다.',
            109: '중복된 브랜드입니다.',
            2: '권한없음',
        },
        writeFailMsg: '브랜드를 등록할 수 없습니다.',
        fileUploadFailMsg: '파일 등록에 실패하였습니다.',
        fileInfo: [
            {
                fileName: 'home_brand',
                fileType: 'home_brand',
                required: false,
                validatorMsg: '홈 원형 이미지를 추가해주세요.',
            },
            {
                fileName: 'introduce_brand',
                fileType: 'introduce_brand',
                required: false,
                validatorMsg: '브랜드 소개 이미지를 추가해주세요.',
            },
            {
                fileName: 'detail_brand',
                fileType: 'detail_brand',
                required: false,
                validatorMsg: '대표이미지를 추가해주세요.',
            },
            {
                fileName: 'look_book_brand',
                fileType: 'look_book_brand',
                required: false,
                validatorMsg: '브랜드 룩북 이미지를 추가해주세요.',
            },
            {
                fileName: 'square_brand',
                fileType: 'square_brand',
                required: false,
                validatorMsg: '브랜드 사각형 이미지를 추가해주세요.',
            },
        ],
        allSetData: true,
        keyName: 'b_idx',
        deleteFunc: 'deleteBrand',
        deleteApiParamsSet: {
        },
        deleteSuccessType: 1,
        deleteFailTypes: {},
    },
    linkBrandItem:{
        filterLayout: 'BrandFilterDefaultLayout',
        listLayout: 'BrandListItemLinkLayout',
        paginationLayout: 'PaginationDefaultLayout',
        listApiParamSet: {
            ip: 1,
            sp: 10,
            page: 1,
        },
        pageRow: 10,
        paginationType: 'pagination',
        getFunc: 'getBrandList',
        excelParamSet:{
            excel:1,
        },
        // excelDownloadFunc:'brand',
        excelDownloadName:'브랜드 목록'
    },
    brandAdver: {
        listLayout: 'BrandListAdverImageLayout',
        listApiParamSet: {
            ip: 0,
        },
        pageRow: 10,
        paginationType: 'pagination',
        getFunc: 'getBrandAd',
        keyName: 'ba_idx',
        deleteFunc: 'deleteBrandAd',
        deleteApiParamsSet: {
        },
        deleteSuccessType: 1,
        deleteFailTypes: {},
    },

    writeBrandAdver: {
        writeLayouts: ['BrandWriteOnlyImageLayout'],
        writeFunc: 'createBrandAd',
        writeApiParamSet: {
        },
        parsingData: {
        },
        directUrl: 'brand-adver-register-modal',
        directType: 'modal',
        writeSuccessType: 1,
        writeFailTypes: {
            '-10': '최대 10개를 초과할수 없습니다.',
        },
        writeFailMsg: '등록에 실패하였습니다.',
        fileUploadFailMsg: '파일 등록에 실패하였습니다.',
        fileInfo: [
            {
                fileName: 'brandAdImg',
                fileType: 'advertisement',
                required: true,
                validatorMsg: '광고 이미지를 추가해주세요.',
            },
        ],
        keyName: 'ba_idx',
    },
}

export default {
    methods: {
        returnBrandConfig(type) {
            return brandConfig[type];
        },
    },
    filterConfig: {
        bname: { // 브랜드명
            type: 'query',
            classname: 'searchInput',
        },
        cr: { // 회원가입일, 탈퇴기간
            type: 'between',
            classname: 'filterCreate',
        },
    },
}
